import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [searchTerm, setSearchTerm] = useState('');

  const faqs = [
    {
      question: '¿Cuánto cuesta una limpieza post incendio en Barcelona?',
      answer: 'El coste depende de varios factores: superficie afectada (m²), gravedad del incendio, número de habitaciones, volumen de enseres a retirar, tipo de materiales, acceso y ascensor, y urgencia. Cada caso es único. Ofrecemos presupuestos personalizados sin compromiso tras una inspección inicial.'
    },
    {
      question: '¿Cuánto tiempo tarda una limpieza completa?',
      answer: 'El tiempo varía según la gravedad. Como ejemplo orientativo, un piso de 90 m² con daños moderados puede tardar entre 3-4 días laborables. Casos más graves pueden requerir una semana o más. Siempre depende del alcance real de los daños y la aprobación del seguro.'
    },
    {
      question: '¿Cubre el seguro este servicio?',
      answer: 'La mayoría de seguros de hogar cubren la limpieza post incendio. Es importante fotografiar todo, contactar con tu aseguradora inmediatamente y esperar la visita del perito antes de iniciar trabajos importantes. Nosotros coordinamos con peritos y facilitamos toda la documentación necesaria para tu reclamación.'
    },
    {
      question: '¿Puedo entrar a casa después del incendio?',
      answer: 'Depende de la gravedad. Tras un incendio, el aire puede contener partículas tóxicas y el hollín puede ser peligroso. No recomendamos habitar el espacio hasta completar la limpieza, desinfección y control de olores. La seguridad es lo primero. Te orientamos caso por caso.'
    },
    {
      question: '¿Qué pasa con mis muebles y ropa?',
      answer: 'Evaluamos cada objeto. Algunos muebles, textiles y objetos personales pueden salvarse con limpieza especializada, otros deben desecharse por seguridad o daño irreparable. No tiramos nada sin tu aprobación y, si hay seguro, sin consultar al perito. Documentamos todo.'
    },
    {
      question: '¿Eliminan el olor a humo por completo?',
      answer: 'Utilizamos tratamientos de desodorización profesionales que reducen significativamente los olores persistentes. En la mayoría de casos logramos eliminarlos por completo, pero depende de la penetración del humo en materiales porosos. Siempre somos realistas y transparentes sobre las expectativas.'
    },
    {
      question: '¿Trabajan con peritos de seguros?',
      answer: 'Sí, tenemos experiencia coordinando con peritos de las principales aseguradoras en Barcelona. Facilitamos informes, fotografías, facturas detalladas y toda la documentación que necesites para tu reclamación. Nuestro objetivo es hacer el proceso lo más sencillo posible para ti.'
    },
    {
      question: '¿Atienden fuera de Barcelona ciudad?',
      answer: 'Sí, trabajamos en Barcelona ciudad y toda el Área Metropolitana (AMB). Si tu municipio no está en nuestra zona habitual, consúltanos igualmente. Evaluamos cada caso y, si es posible, nos desplazamos. Llámanos para confirmar cobertura en tu zona.'
    }
  ];

  const filteredFaqs = faqs.filter(faq =>
    faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
    faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <section className="py-20 bg-bg">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif font-bold text-4xl md:text-5xl text-primary mb-6">
            Preguntas frecuentes
          </h2>
          <p className="text-textLight text-lg mb-8">
            Resolvemos las dudas más comunes sobre limpieza post incendio en Barcelona.
          </p>
          
          {/* Search Input */}
          <div className="relative max-w-xl mx-auto">
            <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-textLight text-xl"></i>
            <input
              type="text"
              placeholder="Buscar duda..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-3 rounded-full border border-gray-300 focus:outline-none focus:border-secondary transition-colors text-sm"
            />
          </div>
        </div>

        {/* Accordion */}
        <div className="space-y-4">
          {filteredFaqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left cursor-pointer"
              >
                <span className="font-sans font-semibold text-base text-primary pr-4">
                  {faq.question}
                </span>
                <i className={`ri-arrow-down-s-line text-2xl text-secondary transition-transform flex-shrink-0 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-textLight text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                  <p className="text-secondary text-sm mt-3">
                    ¿Necesitas más detalles?{' '}
                    <a href="tel:+34690220944" className="underline hover:text-primary cursor-pointer">
                      Llámanos
                    </a>
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Link to Full FAQ */}
        <div className="text-center mt-12">
          <a
            href="/faq"
            className="inline-block bg-secondary text-white px-8 py-4 rounded-full font-sans font-semibold hover:bg-opacity-90 transition-all whitespace-nowrap cursor-pointer"
          >
            Ver todas las preguntas frecuentes
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}